module.exports = __webpack_public_path__ + "static/media/pay with credit card.01a7bb56.png";